import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  title?: string;
  description?: string;
  cta?: {
    label: string;
    url: string;
  },
  backgroundImage?: string;
  comparison?: {
    name: string;
    model1: string;
    model2: string;
    features: {
      description: string;
      checked: 'NONE' | 'MODEL1' | 'MODEL2' | 'BOTH'
    }[]
  }
}

const propsSchema: PropsSchemaList = [
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'description',
    label: 'Description',
    type: types.TEXT,
  },
  {
    key: 'cta',
    label: 'CTA',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'backgroundImage',
    label: 'Background Image',
    type: types.S3_ASSET_URL,
  },
  {
    key: 'comparison',
    label: 'Comparison',
    type: types.OBJECT,
    children: [
      {
        key: 'name',
        label: 'Name',
        type: types.TEXT,
      },
      {
        key: 'model1',
        label: 'Model 1 Name',
        type: types.TEXT,
      },
      {
        key: 'model2',
        label: 'Model 2 Name',
        type: types.TEXT,
      },
      {
        key: 'features',
        label: 'Features',
        type: types.ARRAY,
        children: [
          {
            key: 'description',
            label: 'Description',
            type: types.TEXT,
          },
          {
            key: 'checked',
            label: 'Checked',
            type: types.ENUM,
            options: ['NONE', 'MODEL1', 'MODEL2', 'BOTH']
          },
        ]
      },
    ]
  },
];

const defaultProps: Props = {
  title: 'FF Membership Benefits',
  description: 'Ecosystem service consists of driving, riding, owning and car sharing ser- vices, through which the car is changed to be a mobile office, mobile living room, or cinema etc. anywhere.',
  cta: {
    label: 'Order FF 91',
    url: '/us/preorder'
  },
  comparison: {
    name: 'Features',
    model1: 'FF 91 Futurist Alliance',
    model2: 'FF 91 Futurist',
    features: [
      {
        description: 'Complimentary Vehicle Upgrade FF 91 to FF 92',
        checked: 'MODEL1'
      },
      {
        description: 'Unlimited high-speed data with Wi-Fi hotspot',
        checked: 'BOTH'
      },
      {
        description: 'Premium streaming services',
        checked: 'BOTH'
      },
      {
        description: '19.2W L2 fast home charger',
        checked: 'BOTH'
      },
      {
        description: 'Home charger installation',
        checked: 'BOTH'
      },
      {
        description: 'Public Charging across FF partner networks',
        checked: 'BOTH'
      },
      {
        description: '20 GB in-car cloud storage',
        checked: 'BOTH'
      },
      {
        description: 'AI voice assistant',
        checked: 'BOTH'
      },
      {
        description: 'Big data based intelligent pre-service',
        checked: 'BOTH'
      },
      {
        description: 'Vehicle 5 Years / 60,000 Miles warranty',
        checked: 'BOTH'
      },
      {
        description: 'UP2U Co-creation',
        checked: 'BOTH'
      },
      {
        description: 'Membership Exclusive Merchandise',
        checked: 'MODEL1'
      },
      {
        description: 'FF 91 Futurist Limo services',
        checked: 'BOTH'
      },
      {
        description: 'Hyperdrive club',
        checked: 'BOTH'
      },
    ]
  }
};

export default {
  title: 'Model Compare',
  id: 'ModelCompare',
  propsSchema,
  defaultProps,
}
